import React from 'react';
import { RendererProps } from '../types';

export function createRenderer(Component) {
	return ({ element }: RendererProps) => {
		return <Component {...element} key={element.id} />;
	};
}
